/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import withAuthenticator from 'HOCs/withAuthenticator';
import { Col, Radio, Row } from 'antd';
import { query } from 'helpers/QueryHelper';
import _ from 'lodash';
import demoBooks from 'modules/Book/components/demoBooks';
import React from 'react';
import { HiViewGrid, HiViewList } from 'react-icons/hi';
import { useMutation } from 'react-query';
import { Button, ListGroup } from 'reactstrap';
import Book from '../../../Book/components/Book';
import allBooks from '../../../Book/components/allBooks';
import CardView from './components/CardView';
import ListView from './components/ListView';

const search = (classId) => {
  return query('p_SACHSO_Teachers_GetFiles', { classId });
};

const Files = ({ loggedInUser }) => {
  const newBooks = demoBooks.filter((x) => x.classId === 7 || x.classId === 10);
  const hiddenBookIds = [11310, 11306]; // Danh sách ID ẩn
  const books =
    loggedInUser.role === 'teacher'
      ? // ? _.filter(_.concat(allBooks, newBooks, demoBooksV2[0]), (x) => {
        _.filter(_.concat(allBooks, newBooks), (x) => {
          return x.schoolTypeId === loggedInUser.schoolTypeId && x.bookType === 'sb' && !hiddenBookIds.includes(x.id);
        })
      : [];
  const [selectedBook, setSelectedBook] = React.useState(null);
  const [files, setFiles] = React.useState([]);
  const [view, setView] = React.useState('card');

  const mutation = useMutation(search, {
    onMutate: (variables) => {},
    onSuccess: (data) => {
      setFiles(data);
    },
  });

  return (
    <React.Fragment>
      {/* {isLoading && <Loading />} */}
      {selectedBook && (
        <Row gutter={[24, 24]} style={{ marginBottom: 24 }}>
          <Col span={8}>
            <Button
              outline
              color='primary'
              size='sm'
              onClick={() => {
                setSelectedBook(null);
              }}
            >
              <span className='btn-inner--icon mr-1'>
                <i className='fas fa-chevron-left' />
              </span>
              <span className='btn-inner--text'>Quay lại</span>
            </Button>
          </Col>
          <Col span={16} style={{ textAlign: 'end' }}>
            <Radio.Group
              defaultValue={view}
              buttonStyle='solid'
              onChange={(e) => {
                setView(e.target.value);
              }}
            >
              <Radio.Button value='card'>
                <HiViewGrid />
              </Radio.Button>
              <Radio.Button value='list'>
                <HiViewList />
              </Radio.Button>
            </Radio.Group>
          </Col>
        </Row>
      )}
      {!selectedBook && (
        <Row gutter={[24, 24]}>
          {books.map((item) => {
            return (
              <Col key={`book-${item.id}`} xxl={6} lg={8} md={8} sm={12} xs={24}>
                <Book
                  item={item}
                  displayFooter={false}
                  // displayDescription={false}
                  onClick={() => {
                    setSelectedBook(item);
                    mutation.mutate(item.classId);
                  }}
                />
              </Col>
            );
          })}
        </Row>
      )}

      <ListGroup className='list' flush>
        {selectedBook && <React.Fragment>{view === 'card' ? <CardView files={files} /> : <ListView files={files} />}</React.Fragment>}
      </ListGroup>
    </React.Fragment>
  );
};

export default withAuthenticator(Files);
